document.addEventListener('DOMContentLoaded', function () {
  const searchForm = document.getElementById('search-form');
  if (searchForm) {
    const selects = searchForm.querySelectorAll('select');
    selects.forEach(function (input) {
      input.addEventListener('change', function (e) {
        searchForm.submit();
      });
    });
  }

  var container = document.getElementById('advert-container');
  const loadMore = document.getElementById('load-more-button');
  if (loadMore) {
    loadMore.querySelector('a').addEventListener('click', function (e) {
      e.preventDefault();
      $.ajax({
        url: '/api/properties.php?offset=' + container.children.length,
        success: function (data) {
          console.log(data);
          container.insertAdjacentHTML('beforeend', data.properties);
          if (data.displayLoadMore == false) {
            loadMore.classList.add('js-hide');
          }
        },
      });
    });
  }
});
